import type React from 'react';
import type { Scheme } from '../types/configs';
import MediaPicker from './MediaPicker';

type AttachmentProps = {
  onMediaAttached: (...args: any[]) => void;
  onMediaAttachedError: (...args: any[]) => void;
  show: boolean;
  scheme: Scheme;
};

const AttachmentButton: React.FC<AttachmentProps> = ({
  onMediaAttached,
  onMediaAttachedError,
  show,
  scheme: {
    header: { messageBarColor },
  },
}) => {
  return (
    <>
      {show && (
        <MediaPicker
          mediaType='image'
          onAttached={onMediaAttached}
          onError={onMediaAttachedError}>
          <button
            type='button'
            style={{ backgroundColor: messageBarColor }}
            className='attachment-button'>
            <i className='fas fa-paperclip' />
          </button>
        </MediaPicker>
      )}
    </>
  );
};

export default AttachmentButton;
